import type { JSX, ReactNode } from 'react'

import { clsx } from 'clsx'

import styles from './ComposerCardList.module.css'

export type ComposerCardListProps = Readonly<{
  emptyState?: ReactNode
  className?: string
  children?: ReactNode
}>

export function ComposerCardList({
  emptyState,
  className,
  children,
}: ComposerCardListProps): JSX.Element {
  const hasEmptyState = emptyState !== undefined && emptyState !== null

  return (
    <section
      className={clsx(
        styles.composerDialogSection,
        hasEmptyState ? styles.composersEmptyState : null,
        className,
      )}
    >
      {hasEmptyState && <div className={styles.emptyState}>{emptyState}</div>}
      {children}
    </section>
  )
}
